import type { ComponentType, SVGAttributes } from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';

import style from '@core/Page/LeftMenu/NavigationItem/NavigationItem.module.scss';

import { Icon, IconType } from '@components/Icon';

interface Props {
    title: any;
    dataTest: string;
    link: string;
    blank?: boolean;
    iconType?: IconType;
    icon?: ComponentType<SVGAttributes<SVGElement>>;
    isSubItem?: boolean;
    onLinkClick(): void;
}

export function NavigationItem({
    title,
    link,
    blank,
    iconType,
    icon: IconComponent,
    isSubItem,
    onLinkClick,
    dataTest,
}: Props) {
    const linkContent = () => {
        return (
            <>
                <div className={style.icon}>
                    {IconComponent ? <IconComponent /> : iconType && <Icon type={iconType} />}
                </div>

                <div className={classnames([style.title])}>{title}</div>
            </>
        );
    };

    return blank ? (
        <a
            href={link}
            className={classnames([style.root, isSubItem && style.subItem])}
            data-test={dataTest}
            data-testid={dataTest}
            target={'_blank'}
        >
            {linkContent()}
        </a>
    ) : (
        <NavLink
            to={link}
            className={({ isActive }) => classnames([style.root, isSubItem && style.subItem, isActive && style.active])}
            onClick={blank ? undefined : onLinkClick}
            target={blank ? '_blank' : undefined}
            draggable={false}
            data-test={dataTest}
            data-testid={dataTest}
        >
            {linkContent()}
        </NavLink>
    );
}
